/** 空文字 / 空白のみ → null。それ以外は前後空白を除いた文字列。 */
export function blankToNull(value: string): string | null {
  const trimmed = value.trim();
  return trimmed.length === 0 ? null : trimmed;
}
